export default "__VITE_ASSET__BBrpndww__"